import { Languages } from "../types/Common";

export const languages: Array<Languages> = [
  { key: "lt" },
  { key: "lv" },
  { key: "et" },
];
